import { createFileRoute } from '@tanstack/react-router'

import { EventsAddEdit } from '@/learnpaths-media-events-summary/components/EventsAddEdit/EventsAddEdit'

export const Route = createFileRoute(
  '/company/_management/events/add/$mediaId',
)({
  component: EventsEdit,
})

function EventsEdit() {
  const { mediaId } = Route.useParams()

  return <EventsAddEdit eventId={mediaId} />
}
